<template>
  <div>
    <v-data-table
      :value="selected"
      :loading="loading"
      :headers="headersByType"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :items="invoices"
      sort-desc
      :show-select="showSelect"
      v-on="listeners"
      @input="$emit('changeSelected', $event)"
    >
      <template v-slot:item.customer="{ item }">
        <span class="mr-2">{{ item.customer }}</span>
        <router-link
          class="text-decoration-none"
          target="_blank"
          :to="
            item.person_id
              ? {
                  name: 'persons.show',
                  params: { id: item.person_id }
                }
              : item.company_id
              ? {
                  name: 'companies.show',
                  params: { id: item.company_id }
                }
              : ''
          "
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">
                mdi-eye-outline
              </v-icon>
            </template>
            <span v-if="item.customer">{{ item.customer }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.type_id="{ item }">
        {{ item.type.name }}
      </template>

      <template v-slot:item.price="{ item }">
        {{ item.price | priceFormat }}
      </template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="ereporter.invoice.show"
          open-in-new-window
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { dateFormat, priceFormat } from '@/modules/_global/filters';
import { isEqual } from 'lodash';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'InvoicesList',
  components: { ActionSlotComponent },

  filters: {
    dateFormat,
    priceFormat
  },

  model: {
    prop: 'selected',
    event: 'changeSelected'
  },

  props: {
    selected: {
      type: Array,
      default: () => []
    },
    invoices: {
      type: Array,
      default: () => []
    },
    meta: {
      type: Object,
      default: () => ({
        total: 0
      })
    },
    options: {
      type: Object,
      default: () => {}
    },
    page: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: 'all',
      validator: prop => ['c', 'b', 'all'].includes(prop)
    },
    itemsPerPage: {
      type: Number,
      default: 100
    },
    sortBy: {
      type: [String, Array],
      default: 'id'
    },
    sortDesc: {
      type: [Boolean, Array],
      default: false
    },
    multiSort: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    },
    columnsByType: {
      c: [0, 2, 3, 4, 5, 6, 7, 8, 9],
      b: [0, 2, 3, 4, 5, 6, 7, 8, 9],
      all: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    }
  }),

  computed: {
    ...mapState(['loading']),
    listeners: function() {
      return Object.assign({}, this.$listeners, {
        'update:options': this.updateOptions
      });
    },
    headers() {
      return [
        {
          text: this.$t('EREPORTER.PERIOD'),
          sortable: true,
          value: 'period'
        },
        {
          text: this.$t('ORDERS.CUSTOMER'),
          sortable: true,
          value: 'customer'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          sortable: true,
          value: 'building_complex_name'
        },
        {
          text: this.$t('ITEM.TYPE'),
          sortable: true,
          value: 'type_id'
        },
        {
          text: this.$t('EREPORTER.INVOICES.INVOICE_NUMBER'),
          sortable: true,
          value: 'invoice_number',
          align: 'right'
        },
        {
          text: this.$t('EREPORTER.TOTAL'),
          sortable: true,
          value: 'price',
          align: 'right'
        },
        {
          text: this.$t('ITEM.UPDATED_AT'),
          sortable: true,
          value: 'updated_at',
          align: 'right'
        },
        {
          text: this.$t('EMPLOYEES.STATUS'),
          sortable: true,
          value: 'status'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    },
    headersByType() {
      const columnsIndexes = this.columnsByType[this.type];

      return this.headers.filter((item, index) => {
        return columnsIndexes.indexOf(index) !== -1;
      });
    }
  },

  methods: {
    updateOptions(options) {
      if (isEqual(options, this.options)) {
        return;
      }

      this.$emit('update:options', options);
    }
  }
};
</script>
